<template>
  <div>
 

 <div style="min-height:120px;"></div>
  <div class="container-fluid mt--6">
	
     
</div>
<!-- end clients list -->    

    
 <div class="container-fluid mt--6">

      <!--start new row-->
      
      <div class="row">
        <div class="col-lg-6">
          <div class="card-wrapper">
            <!-- Input groups -->
            <card>
              <!-- Card header -->
              <h3 v-if="is_create == 1" slot="header" class="mb-0">Create Client</h3>
              <h3 v-else slot="header" class="mb-0">Update Client</h3>
              
              
              <!-- Card body -->
              <form class="needs-validation"   @submit.prevent="submit_form">
                <!-- Input groups with icon -->
        		
        		
        		  <div class="row">
                  <div class="col-md-6">
                    <base-input required label="Client Type">
                      <el-select v-model="model.client_type" >
                        <el-option v-for="option in client_type_options"
                                   :key="option.label"
                                   :label="option.label"
                                   :value="option.value">
                        </el-option>
                      </el-select>
                    </base-input>
                  </div>
                  <div class="col-md-6">
                    
                  </div>
                </div>
                <!-- end row -->
                
                
                
                
                
                <div class="row">
                  <div class="col-md-12">
                  
                  <base-input label="Client Name"
                      name="client name"
                      placeholder=""
                      required
                      v-model="model.client_name">
          			</base-input>
          
          
        
                  </div>
                  <div class="col-md-6">
                  </div>
                </div>
                
                 <!-- end row -->
                 
                 
                  <div class="row">
                  <div class="col-md-6">
                  
                  <base-input label="Client Email"
                      name="Client email"
                      placeholder=""
                      required
                      v-model="model.client_email">
          			</base-input>
          
          
        
                  </div>
                  <div class="col-md-6">
                  </div>
                </div>
                
                 <!-- end row -->
                 
                 
                 
                 <div class="row">
                  <div class="col-md-6">
                  
                  <base-input label="Client Contact Number"
                      name="contact number"
                      placeholder=""
                      required
                      v-model="model.contact_number">
          			</base-input>
          
          
        
                  </div>
                  <div class="col-md-6">
                  </div>
                </div>
                
                 <!-- end row -->
                 
                 
                   
                 <div class="row">
                  <div class="col-md-6">
                  
                  <base-input label="Contact Person"
                      name="contact person"
                      placeholder=""
                      v-model="model.contact_person">
          			</base-input>
          
          
        
                  </div>
                  <div class="col-md-6">
                  </div>
                </div>
                
                 <!-- end row -->
                 
                 
                 
                 
                 <div class="row">
                  <div class="col-md-12">
                  
                  <base-input  label="Client Address"
                      name="Client address"
                      placeholder=""
                      required
                      v-model="model.client_address">
          			</base-input>
          
          
        
                  </div>
                  <div class="col-md-6">
                  </div>
                </div>
                
                 <!-- end row -->
                 
                 
                  <div  class="row">
                  <div class="col-md-6">
                  
                  <base-input label="Postal Code"
                      name="Postal code"
                      placeholder=""
                      required
                      v-model="model.postal_code">
          			</base-input>
          
          
        
                  </div>
                  <div class="col-md-6">
                  </div>
                </div>
                
                 <!-- end row -->
                 
                 
               
               
                
                
                
                <base-input label="Remarks">
                    <textarea class="form-control" v-model="model.remarks"  rows="3"></textarea>
                 </base-input>
                  
                  
                  

                  
                
                <div>
                	<base-button v-if="is_create == 1" type="info" block native-type="submit">Add Client</base-button>
                	<base-button v-else type="info" block native-type="submit">Update Client</base-button>
                </div>
              
              </form>
            </card>
            </div>
            </div>
            </div>
            
      
      
      





    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>
  import { Select, Option, Table, TableColumn, Tabs, TabPane,} from 'element-ui'
  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  //import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
  

  export default {
    components: {
  	  [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      TabPane,
      Tabs,
     // DropzoneFileUpload,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
     	 clients:[],
     	 code: "",
     	 is_create: 1,
     	 inputs: {
          fileSingle: [],
          fileMultiple: []
        },
     	 model:{
     	 	client_name:'',
     	 	client_address:'',
     	 	contact_number:'',
     	 	client_email: '',
     	 	contact_person: '',
     	 	remarks:'',
     	 	client_type:1,
     	 	fileSingle: [],
     	 },
     	 et_type_options:[],
     	 et_subtype_options:[],
     	 et_subtype_all_options:[],
     	 client_type_options: [
          {
            label: 'Company',
            value: 1
          },
          {
            label: 'Individual',
            value: 2
          },
        ],
	
      };
    },
    methods: {
    	uploadPhoto(){
    		
    			swal.showLoading();
  				var vm = this;

				let uploaded_file = this.$refs.new_file.files[0];
      			let formData = new FormData();
  			    formData.append('file', uploaded_file);    
  			    formData.append('client_id', this.model.id);
  			    //formData.append('kd_document_name', this.new_key_document.document_name);
  			    //formData.append('kd_remarks', this.new_key_document.remarks);
  			    
  			    
  			      				
  				let uri = vm.$base_url+'/api/clients/post/upload_logo';
				ApiService.post(uri, formData).then(response => {
					var msg = "Photo Uploaded.";
					
					
			
			 		if(response.data.success == "y"){
			 				swal.fire({
									title: `Success`,
									text: msg,
									buttonsStyling: false,
									confirmButtonClass: 'btn btn-success',
									icon: 'success'
							});
			 		}
			 		else{
			 			swal.fire({
									title: 'Error',
									text: response.data.error,
									buttonsStyling: false,
									confirmButtonClass: 'btn btn-success',
									icon: 'warning'
							});
			 			
			 		}
			 })//end api service			
    	
    	
    	
    	
    	},
  		submit_form(){
  				swal.showLoading();
  				var vm = this;
  				
  				vm.model.is_create  = this.is_create;
  				
  				let uri = vm.$base_url+'/api/clients/post/create_client';
				ApiService.post(uri, vm.model).then(response => {
					var msg = "Client Created.";
					
					if(vm.model.is_create ==  0){
						msg = "Client Details Updated."
					}
					
				
			 		if(response.data.success == "y"){
			 				swal.fire({
									title: `Success`,
									text: msg,
									buttonsStyling: false,
									confirmButtonClass: 'btn btn-success',
									icon: 'success'
							}).then((result)=> {	
				  
				  		 			if (result.isConfirmed) {
				  		 			
				  		 				this.$router.push( '/manage-client/'+response.data.client_id)
				  		 			
				  		 			}
				  		 			
				  		 	});
			 		}
			 		else{
			 			swal.fire({
									title: 'Error',
									text: response.data.error,
									buttonsStyling: false,
									confirmButtonClass: 'btn btn-success',
									icon: 'warning'
							});
			 			
			 		}
			 })//end api service
  		},
  		viewClient(index, row) {
  			this.$router.push( '/manage-client/'+row.id)
  		
  		},
  		viewReports(index, row) {
  			this.$router.push( '/view-reports/'+row.id)
  		},
  		addReport(index, row) {
  			this.$router.push( '/add-report/'+row.id)
  		
  		},
  		et_change(){
  			
  			this.et_subtype_options = this.et_subtype_all_options[this.model.equipment_type][0];
  			this.model.equipment_subtype = this.et_subtype_options[0]['value'];
			
  		},
  		page_load(){
  			if(this.$route.params.cid == 0){
  				this.is_create = 1;
  			
  			}
  			else{
  				this.is_create = 0;
				swal.showLoading();
				let uri = this.$base_url+'/api/clients/get/client/'+this.$route.params.cid;
				 ApiService.get(uri).then(response => {
			 
					 const vm = this;

					 this.model = response.data.client;
					 swal.close();
   
				})
  		
  		
  			}
  		},
  		to_confirm(){
  			
  		
  			var vm = this;
  			swal.fire({
					title: 'Are you sure?',
					text: 'You are changing the password for the virtual tour to:     '+ this.model.code,
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
					confirmButtonText: 'Yes, proceed.',
					buttonsStyling: false
				  }).then((result)=> {	
				  
				  		 if (result.isConfirmed) {
				  		 	 var $base_url = "https://kh.rollingatlas.com/kh/public";
				  			 let uri = vm.$base_url+'/api/change_code';
							 ApiService.post(uri, vm.model).then(response => {
			 						if(response.data.success == "y"){
			 							vm.code = response.data.code;
			 							swal.fire({
												title: `Success`,
												text: 'Virtual Tour Password Updated.',
												buttonsStyling: false,
												confirmButtonClass: 'btn btn-success',
												icon: 'success'
										 });
			 						}
			 				})
				  		 
				  		 }
				  		 else{
				  		 
				  		 
				  		 }
				  			
			 
					}
					
					)//end swal

  		}
    },
    mounted() {
      	
      	this.page_load();
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














